import ContainerV2 from '@components/ui/ContainerV2/ContainerV2'
import groupArray from '@lib/helpers/groupArray'
import { InspirationElementFragment } from '@lib/umbraco/generated/types.generated'
import clsx from 'clsx'
import TrendGridItem from './TrendGridItem'
import s from './TrendGridView.module.scss'

export type TrendGridViewProps = {
  headingText: string
  modules: InspirationElementFragment[]
}

const TrendGridView: React.FC<TrendGridViewProps> = ({
  headingText,
  modules,
}) => {
  return (
    <ContainerV2>
      <div className={clsx(s.root)}>
        <div className={s.heading}>{headingText}</div>
        <div className={s.grid}>
          {groupArray(modules, 2).map((item, index) => (
            <div className={s.row} key={index}>
              <div className={clsx(s.column, {})}>
                <div
                  className={clsx(s.item, {
                    [s.small]: (index * 2) % 3 !== 0,
                    [s.large]: (index * 2) % 3 === 0,
                  })}
                >
                  <TrendGridItem
                    {...item[0]}
                    large={(index * 2) % 3 === 0}
                    itemIndex={index * 2}
                  />
                </div>
              </div>

              <div className={clsx(s.column, {})}>
                <div
                  className={clsx(s.item, {
                    [s.small]: (index * 2 + 1) % 3 !== 0,
                    [s.large]: (index * 2 + 1) % 3 === 0,
                  })}
                >
                  {item.length > 1 && (
                    <TrendGridItem
                      {...item[1]}
                      large={(index * 2 + 1) % 3 === 0}
                      itemIndex={index * 2 + 1}
                    />
                  )}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </ContainerV2>
  )
}

export default TrendGridView

//function that group array into sets of two
